import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';

export default function Footer({ intl }) {
	return (
		<div className="footer-top">
			<footer className="container">

				<div className="info">
					<p className="info__company">© Everad 2012-{moment().format('YYYY')}</p>
				</div>

				<div className="links">
					<ul>
						<li><a href="https://everad.com" target="_blank" rel="noopener">{intl('О нас')}</a></li>
						<li><a href="https://everad.com/terms" target="_blank" rel="noopener">{intl('Правила')}</a></li>
						<li>
							<a href="https://everad.com/privacy" target="_blank" rel="noopener">{intl('Конфиденциальность')}</a>
						</li>
						<li><a href="https://everad.com/faq" target="_blank" rel="noopener">FAQ</a></li>
					</ul>
				</div>
				<div className="links links-large">
					<ul>
						<li><a href="https://everad.com/" target="_blank" rel="noopener">{intl('Вебмастеру')}</a></li>
						<li><a href="https://everad.com" target="_blank" rel="noopener">{intl('О системе')}</a></li>
						<li><a href="https://blog.everad.com" target="_blank" rel="noopener">{intl('Блог')}</a></li>
						<li><a href="https://everad.com/contacts" target="_blank" rel="noopener">{intl('Контакты')}</a></li>
					</ul>
				</div>

				<div className="contacts">

					<p>
						<span className="contacts__email">E-mail: </span>
						<a href="mailto:support@everad.com">support@everad.com</a>
					</p>

					<p>
						<span className="contacts__telegram">Telegram: </span>
						<a href="https://telegram.me/Everad_Support" target="_blank" rel="noopener">@Everad_Support</a>
					</p>
				</div>

				<div className="additional clearfix">
					<div className="info__social">
						<a href="https://www.facebook.com/everadgroup" className="info__social-fb" target="_blank" rel="noopener" />
						<a href="https://www.instagram.com/everad_group"
							className="info__social-insta" target="_blank" rel="noopener" />
						<a href="https://twitter.com/everadgroup" className="info__social-tw" target="_blank" rel="noopener" />
					</div>

				</div>
			</footer>
		</div>
	);
}

Footer.propTypes = {
	intl: PropTypes.func
};



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/everad/modules/footer/main.js